// src/components/Header.jsx (for Public Portal)
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { zampassLogout } from "../services/api";
import { User } from 'lucide-react';
import './Header.css';

// Icon placeholders

const ChevronDown = () => <span>▼</span>;

const Header = () => {
    const { isAuthenticated, user, logout } = useAuth();
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleLogout = async () => {
        const site = "public";
        const zamPassIdToken = localStorage.getItem('zamPassIdToken');
        console.log("zp", zamPassIdToken)

        try {
            if (user?.zampassId && zamPassIdToken) {
                // ZAMPASS LOGOUT FLOW
                const response = await zampassLogout(site, zamPassIdToken);
                console.log("ZamPass logout response:", response.data);

                // // Redirect to ZamPass end session URL if returned
                if (response?.data?.logoutUrl) {
                    window.location.href = response.data.logoutUrl;
                } else {
                    //     // If API doesn’t return redirectUrl, do local fallback
                    logout();
                    navigate('/');
                }
            } else {
                // LOCAL LOGOUT FLOW
                logout();
                navigate('/');
            }
        } catch (error) {
            console.error("Logout error:", error);
            logout(); // Always ensure local cleanup
            navigate('/');
        }
    };

    const logoUrl = "/img/logo.svg";

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="new-app-header">
            {/* Top bar with user info */}
            <div className="top-bar">
                <div className="top-bar-content">
                    {isAuthenticated ? (
                        <>
                            {/* Full user info (shown on larger screens) */}
                            <div className="user-info full-user-info">
                                <User />
                                <span>{user?.name || user?.email}</span>
                            </div>
                            <div className="user-info full-user-info">
                                <User />
                                <span>Corporate Account</span>
                            </div>

                            {/* ✅ Small screen user bubble */}
                            <div className="user-bubble">
                                {user?.name
                                    ? user.name.charAt(0).toUpperCase()
                                    : user?.email
                                        ? user.email.charAt(0).toUpperCase()
                                        : 'U'}
                            </div>
                        </>
                    ) : (
                        <div></div>
                    )}

                    <button className="language-selector" style={{ display: 'none' }}>
                        <span>English</span>
                        <ChevronDown />
                    </button>
                </div>
            </div>

            {/* Main header with logo and navigation */}
            <div className="main-header">
                <div className="main-header-content">
                    {/* Logo and title */}
                    <div className="logo-title">
                        <Link to="/" className="logo-link">
                            <img
                                src={logoUrl}
                                alt="ZamServices Logo"
                                className="logo-img"
                            />
                        </Link>
                        <div className="title-group">
                            <span className="main-title-text">ZamServices</span>
                            <span className="subtitle-text">Government e-Services Directory</span>
                        </div>
                    </div>

                    {/* Hamburger Menu */}
                    <div className="hamburger-menu" onClick={toggleMenu}>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>

                    {/* Navigation */}
                    <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`}>
                        <button onClick={() => { window.open("https://zamportal.gov.zm/", "_blank"); setIsMenuOpen(false); }} className="nav-link-button">
                            ZamPortal
                        </button>
                        <button onClick={() => { navigate("/services"); setIsMenuOpen(false); }} className="nav-link-button active">
                            E-Services Directory
                        </button>
                        <button onClick={() => { navigate(isAuthenticated ? '/my-workplace' : '/login'); setIsMenuOpen(false); }} className="nav-link-button">
                            My Workplace
                        </button>
                        {!isAuthenticated && (
                            <>
                                <button onClick={() => { navigate('/login'); setIsMenuOpen(false); }} className="signin-button">
                                    <User />
                                    Sign In
                                </button>
                                <button onClick={() => { navigate('/register'); setIsMenuOpen(false); }} className="nav-link-button" style={{ display: 'none' }}>
                                    Register
                                </button>
                            </>
                        )}
                        {isAuthenticated && (
                            <button onClick={() => { handleLogout(); setIsMenuOpen(false); }} className="nav-link-button logout-button">
                                Logout
                            </button>
                        )}
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header;